import {
  ref, reactive, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { parseRequestError, copyToClipboard } from '@/helpers/helpers'
import ct from 'countries-and-timezones'
import i18n from '@/libs/i18n'
import { required, email } from '@validations'
import Type from '@/auth/type'

export default () => {
  const me = computed(() => store.getters['auth/getUser'])

  const user = reactive({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    timezone: 'Europe/Warsaw',
  })

  const timezoneOptions = ref([])
  const phoneNumberValid = ref(true)
  const processing = ref(false)
  const refProfileForm = ref(null)

  const isTeacher = computed(() => me.value && me.value.type === Type.teacher)

  const publicCalendarUrl = computed(() => {
    const base = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '')
    const hash = me.value && me.value.calendar && me.value.calendar.hash
    return hash ? `${base}/public/calendars/${hash}` : ''
  })

  const copyCalendarUrl = async () => {
    const text = publicCalendarUrl.value
    if (!text) return
    await copyToClipboard(text)
  }

  onMounted(() => {
    Object.assign(user, me.value)
    timezoneOptions.value = Object.values(ct.getAllTimezones()).map(tz => ({ value: tz.name, text: tz.name }))
  })

  const handlePhoneValidation = phoneObject => {
    phoneNumberValid.value = !!phoneObject.valid || !phoneObject.formatted
  }

  const save = () => {
    refProfileForm.value.validate()
      .then(valid => {
        if (!valid || !phoneNumberValid.value) return
        processing.value = true
        store.dispatch('user/updateMyProfile', user)
          .then(() => {
            store.dispatch('auth/fetchUserInfo')
            window.toast.notify.success(i18n.t('user.profile.toast.updated'))
          })
          .catch(err => parseRequestError(err))
          .finally(() => { processing.value = false })
      })
  }

  return {
    me,
    user,
    timezoneOptions,
    phoneNumberValid,
    processing,
    refProfileForm,
    isTeacher,
    publicCalendarUrl,
    copyCalendarUrl,
    handlePhoneValidation,
    save,
    required,
    email,
  }
}
